import { ProfileWebhookLogsListComponent } from "@frontend/profile/webhook-logs/list/list.component";

export const profileWebhookLogsRoutes = {
  path: 'webhook-logs',
  component: ProfileWebhookLogsListComponent
};